import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import styles from './AdminDashboard.module.css';
import {
  UserIcon,
  TagIcon,
  BookIcon,
  FileIcon,
  PlusIcon,
  FolderIcon,
  CheckIcon,
  BarChartIcon,
  InfoIcon
} from '../../components/Icons';

function AdminDashboard() {
  const [stats, setStats] = useState({
    users: 0,
    categories: 0,
    novels: 0,
    chapters: 0,
    loading: true
  });

  useEffect(() => {
    const previousOverflowY = document.body.style.overflowY;
    document.body.style.overflowY = 'auto';

    return () => {
      document.body.style.overflowY = previousOverflowY;
    };
  }, []);

  useEffect(() => {
    fetchDashboardStats();
  }, []);

  const fetchDashboardStats = async () => {
    try {
      setStats(prev => ({ ...prev, loading: true }));
      
      // 并行获取各种统计数据
      const [usersRes, categoriesRes, novelsRes, chaptersRes] = await Promise.all([
        api.get('/users/'),
        api.get('/categories/'),
        api.get('/novels/'),
        api.get('/chapters/')
      ]);

      setStats({
        users: usersRes.data.length || 0,
        categories: categoriesRes.data.length || 0,
        novels: novelsRes.data.length || 0,
        chapters: chaptersRes.data.length || 0,
        loading: false
      });
    } catch (error) {
      console.error('获取统计数据失败:', error);
      console.error('错误详情:', error.response?.data || error.message);
      setStats(prev => ({ ...prev, loading: false }));
      
      // 显示更详细的错误信息
      alert(`获取统计数据失败: ${error.response?.data?.detail || error.message || '未知错误'}`);
    }
  };

  const StatCard = ({ title, value, icon, color, description }) => (
    <div className={`${styles.statCard} ${styles[color]}`}>
      <div className={styles.statIcon}>{icon}</div>
      <div className={styles.statContent}>
        <h3 className={styles.statTitle}>{title}</h3>
        <div className={styles.statValue}>
          {stats.loading ? '...' : value.toLocaleString()}
        </div>
        <p className={styles.statDescription}>{description}</p>
      </div>
    </div>
  );

  const QuickAction = ({ title, description, icon, onClick, color }) => (
    <div className={`${styles.quickAction} ${styles[color]}`} onClick={onClick}>
      <div className={styles.actionIcon}>{icon}</div>
      <div className={styles.actionContent}>
        <h4 className={styles.actionTitle}>{title}</h4>
        <p className={styles.actionDescription}>{description}</p>
      </div>
    </div>
  );

  return (
    <div className={styles.dashboard}>
      <div className={styles.dashboardHeader}>
        <h1 className={styles.dashboardTitle}>仪表板</h1>
        <p className={styles.dashboardSubtitle}>欢迎回到管理员控制台</p>
      </div>

      {/* 统计卡片 */}
      {/* <div className={styles.statsGrid}>
        <StatCard
          title="用户总数"
          value={stats.users}
          icon={<UserIcon size={28} />}
          color="blue"
          description="注册用户数量"
        />
        <StatCard
          title="分类总数"
          value={stats.categories}
          icon={<TagIcon size={28} />}
          color="green"
          description="小说分类数量"
        />
        <StatCard
          title="小说总数"
          value={stats.novels}
          icon={<BookIcon size={28} />}
          color="purple"
          description="收录小说数量"
        />
        <StatCard
          title="章节总数"
          value={stats.chapters}
          icon={<FileIcon size={28} />}
          color="orange"
          description="所有章节数量"
        />
      </div> */}

      {/* 快速操作 */}
      <div className={styles.quickActions}>
        <h2 className={styles.sectionTitle}>快速操作</h2>
        <div className={styles.actionsGrid}>
          <QuickAction
            title="添加新用户"
            description="创建新的用户账户"
            icon={<PlusIcon size={20} />}
            color="blue"
            onClick={() => window.location.href = '/admin/users'}
          />
          <QuickAction
            title="管理分类"
            description="添加或编辑小说分类"
            icon={<TagIcon size={20} />}
            color="green"
            onClick={() => window.location.href = '/admin/categories'}
          />
          <QuickAction
            title="添加小说"
            description="录入新的小说作品"
            icon={<BookIcon size={20} />}
            color="purple"
            onClick={() => window.location.href = '/admin/novels'}
          />
          <QuickAction
            title="内容管理"
            description="管理章节和卷"
            icon={<FolderIcon size={20} />}
            color="orange"
            onClick={() => window.location.href = '/admin/chapters'}
          />
        </div>
      </div>

      {/* 最近活动 */}
      <div className={styles.recentActivity}>
        <h2 className={styles.sectionTitle}>系统状态</h2>
          <div className={styles.activityCard}>
            <div className={styles.activityItem}>
              <div className={styles.activityIcon}>
                <CheckIcon size={18} />
              </div>
              <div className={styles.activityContent}>
                <h4>数据库连接正常</h4>
                <p>所有数据库服务运行正常</p>
              </div>
              <span className={styles.activityTime}>实时</span>
            </div>
            <div className={styles.activityItem}>
              <div className={styles.activityIcon}>
                <BarChartIcon size={18} />
              </div>
              <div className={styles.activityContent}>
                <h4>统计数据已更新</h4>
                <p>最新的用户和内容统计</p>
              </div>
              <span className={styles.activityTime}>刚刚</span>
            </div>
            <div className={styles.activityItem}>
              <div className={styles.activityIcon}>
                <InfoIcon size={18} />
              </div>
              <div className={styles.activityContent}>
                <h4>管理员权限已验证</h4>
                <p>您拥有完整的管理权限</p>
            </div>
            <span className={styles.activityTime}>登录时</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AdminDashboard;
